export default "__VITE_ASSET__Bfp5F7iS__"